import { Button, Card, Flex, Text } from '@servicetitan/anvil2';

interface PrequalChoiceScreenProps {
    onPrequalify: () => void;
    onApplyNow: () => void;
}

export const PrequalChoiceScreen = ({ onPrequalify, onApplyNow }: PrequalChoiceScreenProps) => {
    return (
        <Flex direction="column" gap="6">
            {/* Explanatory text */}
            <Text variant="body" size="medium" color="subdued">
                Not sure which to choose? Start with pre-qualifying to see your options without
                affecting your credit score. You can always complete the application later.
            </Text>

            {/* Option cards */}
            <Flex direction="column" gap="4">
                {/* Prequalification option */}
                <Card>
                    <Flex direction="column" gap="3" style={{ padding: '8px' }}>
                        <Text variant="headline" size="medium" el="h3">
                            Check if you pre-qualify
                        </Text>
                        <Text variant="body" size="medium" color="subdued">
                            It only takes a few minutes to see if you pre-qualify, and there is no
                            impact to your credit score.
                        </Text>
                        <Button
                            appearance="primary"
                            onClick={onPrequalify}
                            style={{ alignSelf: 'stretch', width: '100%' }}
                        >
                            See If You Pre-qualify
                        </Button>
                        <Text variant="body" size="small" subdued>
                            We are unable to pre-qualify customers without a Social Security number.
                            If you have an Individual Tax Identification Number (ITIN), please skip
                            the pre-qualification process and complete a credit application using
                            your ITIN.
                        </Text>
                    </Flex>
                </Card>

                {/* Full application option */}
                <Card>
                    <Flex direction="column" gap="3" style={{ padding: '8px' }}>
                        <Text variant="headline" size="medium" el="h3">
                            Complete application
                        </Text>
                        <Text variant="body" size="medium" color="subdued">
                            Submit an application with Wells Fargo. A hard credit inquiry required
                            which may impact your credit score.
                        </Text>
                        <Button
                            appearance="secondary"
                            onClick={onApplyNow}
                            style={{ alignSelf: 'stretch', width: '100%' }}
                        >
                            Apply Now
                        </Button>
                    </Flex>
                </Card>
            </Flex>
        </Flex>
    );
};
